import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { DocFlowScopeBuildingGroupsField } from '../../../DocFlowScopeBuildingGroupsField'
import { DocFlowScopeBuildingsField } from '../../../DocFlowScopeBuildingsField'

function DocFlowFormBuildingScopeFields() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <>
      <DocFlowScopeBuildingGroupsField
        controlProps={{ borderless: !isMobileScreenSize }}
        fieldComponentProps={{ shouldAdaptToMobileScreen: true }}
        label={`${t('DocFlow.FormBuildingGroupsFieldLabelKey')}:`}
      />
      <DocFlowScopeBuildingsField
        controlProps={{ borderless: !isMobileScreenSize }}
        fieldComponentProps={{ shouldAdaptToMobileScreen: true }}
        label={`${t('DocFlow.FormBuildingsFieldLabelKey')}:`}
      />
    </>
  )
}

export default DocFlowFormBuildingScopeFields
